import { AxiosError } from 'axios';
import { NON_NATIONAL_EXAM_APPLICATION_LISTING } from '../../constants/apiUrls';
import axiosClient from '../axiosClient';
import { useCustomMutation } from '../utils/useCustomMutation';
import { ApiPathParam } from '../../models/SearchParamSchema';
import { PaginatedData } from '../../models/List';
import {GenericErrorResponse} from "../typings";

export interface NonNationalExamApplicationSearchRequest {
  examLevel?: string;
  status?: string;
  search?: string;
  apiParams: ApiPathParam;
}

// =============================================================================
// Mutation
// =============================================================================
interface Input {
  onSuccess?: (data: PaginatedData<NonNationalExamApplicationReviewResponse>) => void;
  onError?: (error: AxiosError<GenericErrorResponse>) => void;
}

interface NonNationalExamApplicationReviewResponse {
  nricFinPassport: string;
  cddtName: string;
  applicationDate: string;
  status: string;
  updateDateTime?: string;
  updateBy?: string;
  uuid: string;
  applicationId: string;
}

export const usePostNonNationalExamApplicationSearch = ({ onSuccess, onError }: Input = {}) => {
  const postNonNationalExamApplicationSearch = async (
    requestBody: NonNationalExamApplicationSearchRequest
  ) => {
    const updatedRequestBody = JSON.parse(JSON.stringify(requestBody));
    delete updatedRequestBody.apiParams;

    const res = await axiosClient.post<PaginatedData<NonNationalExamApplicationReviewResponse>>(
      NON_NATIONAL_EXAM_APPLICATION_LISTING(requestBody.apiParams),
      updatedRequestBody
    );

    return res.data;
  };

  return useCustomMutation(postNonNationalExamApplicationSearch, {
    onSuccess,
    onError,
  });
};
